import React from 'react';
import PropTypes from 'prop-types';

export const Earth = ({ width, height, ...props }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='currentColor'
      d='M12 22a9.738 9.738 0 0 1-3.9-.788 10.099 10.099 0 0 1-3.175-2.137c-.9-.9-1.612-1.958-2.137-3.175A9.738 9.738 0 0 1 2 12c0-1.383.263-2.683.788-3.9a10.099 10.099 0 0 1 2.137-3.175c.9-.9 1.958-1.612 3.175-2.137A9.738 9.738 0 0 1 12 2c1.383 0 2.683.263 3.9.788a10.098 10.098 0 0 1 3.175 2.137c.9.9 1.613 1.958 2.137 3.175A9.738 9.738 0 0 1 22 12a9.738 9.738 0 0 1-.788 3.9 10.098 10.098 0 0 1-2.137 3.175c-.9.9-1.958 1.613-3.175 2.137A9.738 9.738 0 0 1 12 22Zm-1-2.05V18c-.55 0-1.02-.196-1.412-.587A1.926 1.926 0 0 1 9 16v-1l-4.8-4.8c-.05.3-.096.6-.138.9-.041.3-.062.6-.062.9 0 2.017.662 3.783 1.987 5.3 1.325 1.517 2.996 2.4 5.013 2.65Zm6.9-2.55a7.99 7.99 0 0 0 1.563-2.512A7.926 7.926 0 0 0 20 12a7.845 7.845 0 0 0-1.363-4.475A7.701 7.701 0 0 0 15 4.6V5c0 .55-.196 1.02-.588 1.412A1.926 1.926 0 0 1 13 7h-2v2c0 .283-.096.52-.287.713A.968.968 0 0 1 10 10H8v2h6c.283 0 .52.096.713.287.191.192.287.43.287.713v3h1c.433 0 .825.13 1.175.387.35.259.592.596.725 1.013Z'
    />
  </svg>
);

Earth.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

Earth.defaultProps = {
  width: 24,
  height: 24,
};
